var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPbLoginHandSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 5,
    fill: "#FFF8E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 13,
    y: 13,
    width: 12,
    height: 12,
    rx: 3,
    fill: "#FFA200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6C14.3786 6 13.4545 6.84712 13.4545 7.875V8.61475C13.2401 8.54396 13.0122 8.5 12.7727 8.5C11.6513 8.5 10.7273 9.34713 10.7273 10.375V11.1147C10.5129 11.044 10.285 11 10.0455 11C8.92407 11 8 11.8471 8 12.875V17.875V18.5V19.125C8 22.923 11.3568 26 15.5 26C19.6432 26 23 22.923 23 19.125V17.875V15.375C23 14.3471 22.0759 13.5 20.9545 13.5C20.715 13.5 20.4871 13.544 20.2727 13.6147V10.375C20.2727 9.34713 19.3487 8.5 18.2273 8.5C17.9878 8.5 17.7599 8.54396 17.5455 8.61475V7.875C17.5455 6.84712 16.6214 6 15.5 6ZM15.5 7.25C15.8895 7.25 16.1818 7.518 16.1818 7.875V16H17.5455V10.375C17.5455 10.018 17.8378 9.75 18.2273 9.75C18.6168 9.75 18.9091 10.018 18.9091 10.375V16V17.875H20.2727V15.375C20.2727 15.018 20.565 14.75 20.9545 14.75C21.3441 14.75 21.6364 15.018 21.6364 15.375V17.875V19.125C21.6364 22.2521 18.9113 24.75 15.5 24.75C12.0887 24.75 9.36364 22.2521 9.36364 19.125V18.5V17.875V12.875C9.36364 12.518 9.65593 12.25 10.0455 12.25C10.435 12.25 10.7273 12.518 10.7273 12.875V16H12.0909V12.875V10.375C12.0909 10.018 12.3832 9.75 12.7727 9.75C13.1622 9.75 13.4545 10.018 13.4545 10.375V16H14.8182V10.375V7.875C14.8182 7.518 15.1105 7.25 15.5 7.25Z",
    fill: "#FF6801"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbLoginHandSign);
export default __webpack_public_path__ + "static/media/pb-login-hand-sign.f16b7fe4a7cbe39c9188452b160ce2ad.svg";
export { ForwardRef as ReactComponent };